import { useState } from "react";
import { featureArticles } from "@/mocks/gossipData";

export default function Feature() {
  const [expanded, setExpanded] = useState<number[]>([]);

  const toggle = (i: number) =>
    setExpanded((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));

  return (
    <section id="feature" className="wrap py-14 md:py-20">
      <div className="text-center">
        <p className="mb-2 text-xs font-bold uppercase tracking-widest text-primary-600">DEEP DIVE</p>
        <h2 className="font-display text-2xl font-black text-foreground-950 md:text-4xl">深度大瓜 · 不止于热闹</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600">
          热闹之后，我们更关心背后的门道。编辑部原创长稿，帮你把一个个现象吃明白。
        </p>
      </div>

      <div className="mt-10 space-y-10">
        {featureArticles.map((f, i) => {
          const isOpen = expanded.includes(i);
          return (
            <article
              key={f.title}
              className="grid overflow-hidden rounded-lg border border-background-200/70 bg-background-50 md:grid-cols-2"
            >
              <div className="relative min-h-[240px] md:min-h-[360px]">
                <img src={f.image} alt={f.title} className="absolute inset-0 h-full w-full object-cover object-top" />
                <span className="absolute left-4 top-4 whitespace-nowrap rounded-md bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-col p-6 md:p-8">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 font-bold text-primary-700">
                    {f.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {f.date}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {f.readTime}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.lead}</p>

                {isOpen && (
                  <div className="mt-4 space-y-3">
                    {f.parts.map((p, idx) => (
                      <p key={idx} className="border-l-2 border-primary-200 pl-3 text-sm leading-relaxed text-foreground-700">
                        {p}
                      </p>
                    ))}
                  </div>
                )}

                <button
                  type="button"
                  onClick={() => toggle(i)}
                  className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
                >
                  {isOpen ? (
                    <>
                      <i className="ri-arrow-up-line"></i>收起正文
                    </>
                  ) : (
                    <>
                      <i className="ri-arrow-down-line"></i>展开全文
                    </>
                  )}
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}